/**
 * Footer
 */
import React from "react";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

// intl messages
import IntlMessages from "Util/IntlMessages";

// app config
import AppConfig from "Constants/AppConfig";

const year = new Date().getFullYear();
 
const Footer = () => (
  <div className="rct-footer d-flex justify-content-between align-items-center">
    {/* <ul className="list-inline footer-menus mb-0">
      <li className="list-inline-item">
        <Button component={Link} to="/app/about-us">
          <IntlMessages id="sidebar.aboutUs" />
        </Button>
      </li>
    </ul> */}
    <h5 className="mb-0">
      {`${AppConfig.copyRightText1}${year}${AppConfig.copyRightText2}`}
    </h5>
  </div>
);

export default Footer;
